export default __webpack_public_path__ + "static/media/execute_detAna.9b670d16.png";